/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_No_AccountsInputs */

const es_settings_sources_no_accounts = /** @type {(inputs: Settings_Sources_No_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cuentas conectadas`)
};

const en_settings_sources_no_accounts = /** @type {(inputs: Settings_Sources_No_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connected accounts`)
};

/**
* | output |
* | --- |
* | "No connected accounts" |
*
* @param {Settings_Sources_No_AccountsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_no_accounts = /** @type {((inputs?: Settings_Sources_No_AccountsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_No_AccountsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_no_accounts(inputs)
	return en_settings_sources_no_accounts(inputs)
});
export { settings_sources_no_accounts as "settings.sources.no_accounts" }